export const Swimwears = [
  {
   title: "Speedo Essential Splice Kneesuit (Navy/Electric Pink)",
    desc: "Speedo Essential Splice Kneesuit (Navy/Electric Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810391P007.jpg",
    currency: "INR ",
    price: "2699",
    mrp: "2699",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice Aquashort (Navy/Zest)",
    desc: "Speedo Essential Splice Aquashort (Navy/Zest) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW809307C831.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Placement Panel All Mens Aquashort (Blue/Red/Mango)",
    desc: "Speedo Placement Panel All Mens Aquashort (Blue/Red/Mango) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW804510B457.jpg",
    currency: "INR ",
    price: "1149",
    mrp: "1149",
    discount: "0% off",
  },
  {
   title: "Speedo Placement Panel All Mens Aquashort (Black/Blue/Red)",
    desc: "Speedo Placement Panel All Mens Aquashort (Black/Blue/Red) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW804510C725.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "1199",
    discount: "0% off",
  },
  {
   title: "Speedo Essentail Houston Jammer (Blue)",
    desc: "Speedo Essentail Houston Jammer (Blue) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8MS411C771.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Racerback Swimdress With Boyleg (Pink/Black)",
    desc: "Speedo Racerback Swimdress with Boyleg (Pink/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8GS878B356.jpg",
    currency: "INR ",
    price: "1699",
    mrp: "1699",
    discount: "0% off",
  },
  {
   title: "Speedo Racerback Swimmdress With Legsuit (Black/Pink)",
    desc: "Speedo Racerback Swimmdress with Legsuit (Black/Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8GS878B344.jpg",
    currency: "INR ",
    price: "1699",
    mrp: "1699",
    discount: "0% off",
  },
  {
   title: "Speedo Printed Racer-Back Swimdress With Boyleg (Navy/Jade)",
    desc: "Speedo Printed Racer-back Swimdress with Boyleg (Navy/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW808876B536.jpg",
    currency: "INR ",
    price: "2599",
    mrp: "2599",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice All Over KneeSuit (Black/Blue/Glare)",
    desc: "Speedo Essential Splice All Over KneeSuit (Black/Blue/Glare) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8FS391P027.jpg",
    currency: "INR ",
    price: "2799",
    mrp: "2799",
    discount: "0% off",
  },
  {
   title: "Speedo Essential All In One Suit (Pink/Blue/White)",
    desc: "Speedo Essential All In One Suit (Pink/Blue/White) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Printed Junior Legsuit (Black/Pink/Blue)",
    desc: "Speedo Printed Junior Legsuit (Black/Pink/Blue) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1399",
    mrp: "1399",
    discount: "0% off",
  },
  {
   title: "Speedo Racer-Back Swimdress With Boyleg (Black/Electric Pink)",
    desc: "Speedo Racer-Back Swimdress with Boyleg (Black/Electric Pink) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1999",
    mrp: "1999",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Junior Legsuit (Blue/Zest)",
    desc: "Speedo Boom Splice Junior Legsuit (Blue/Zest) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810845C901.jpg",
    currency: "INR ",
    price: "1399",
    mrp: "1399",
    discount: "0% off",
  },
  {
   title: "Speedo Fantacy Essential All In One Suit (Pink/Blue/White)",
    desc: "Speedo Fantacy Essential All In One Suit (Pink/Blue/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW805592C197.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Racer-Back Swimdress With Boyleg (Black/Electric Pink)",
    desc: "Speedo Racer-Back Swimdress with Boyleg (Black/Electric Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW802878B344.jpg",
    currency: "INR ",
    price: "2199",
    mrp: "2199",
    discount: "0% off",
  },
  {
   title: "Speedo Racer-Back Swimdress With Boyleg (Pink/Black)",
    desc: "Speedo Racer-back Swimdress with Boyleg (Pink/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW802878B356.jpg",
    currency: "INR ",
    price: "1999",
    mrp: "1999",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Aquashort (Black/White/LavaRed)",
    desc: "Speedo Boom Splice Aquashort (Black/White/LavaRed) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810855B444.jpg",
    currency: "INR ",
    price: "1299",
    mrp: "1299",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo AquaShorts (Navy/Zest)",
    desc: "Speedo Gala Logo AquaShorts (Navy/Zest) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811354C831.jpg",
    currency: "INR ",
    price: "949",
    mrp: "949",
    discount: "0% off",
  },
  {
   title: "Speedo Boom AquaShort (Navy/Orange)",
    desc: "Speedo Boom AquaShort (Navy/Orange) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810855C840.jpg",
    currency: "INR ",
    price: "1299",
    mrp: "1299",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice Knee Suit (Teal/Grey/Black)",
    desc: "Speedo Essential Splice knee Suit (Teal/Grey/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810391P026.jpg",
    currency: "INR ",
    price: "2499",
    mrp: "2499",
    discount: "0% off",
  },
  {
   title: "Speedo Boom AquaShort (Black/Zest/Blue)",
    desc: "Speedo Boom AquaShort (Black/Zest/Blue) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810855C713.jpg",
    currency: "INR ",
    price: "1299",
    mrp: "1299",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Black/Zest/Blue)",
    desc: "Speedo Boom Splice Jammer (Black/Zest/Blue) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo Thin Strap Swimwear (Black/Pink)",
    desc: "Speedo Gala Logo Thin Strap Swimwear (Black/Pink) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice Aquashort (Navy/Jade)",
    desc: "Speedo Essential Splice Aquashort (Navy/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW809307B353.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice Aquashort (Black/Lava Red)",
    desc: "Speedo Essential Splice Aquashort (Black/Lava Red) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW809307B346.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Solid Swim Capri (Black /Pink)",
    desc: "Speedo Solid Swim Capri (Black /Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8PSF03B344.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Printed Boom Splice Capri (Black/Pink)",
    desc: "Speedo Printed Boom Splice Capri (Black/Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8PSF04B388.jpg",
    currency: "INR ",
    price: "1499",
    mrp: "1499",
    discount: "0% off",
  },
  {
   title: "Speedo Monogram Legsuit (Black/Magenta)",
    desc: "Speedo Monogram Legsuit (Black/Magenta) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8087373597.jpg",
    currency: "INR ",
    price: "2199",
    mrp: "2199",
    discount: "0% off",
  },
  {
   title: "Speedo Lycra Racer-Back Swimdress (Navy/White)",
    desc: "Speedo Lycra Racer-back Swimdress (Navy/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8007097780.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Solid Leisure 15 Watershorts (Navy)",
    desc: "Speedo Solid Leisure 15 Watershorts (Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8356917780.jpg",
    currency: "INR ",
    price: "899",
    mrp: "899",
    discount: "0% off",
  },
  {
   title: "Speedo Boys Jumpin Printed Leisure 17 Watershorts (Black/Blue/White)",
    desc: "Speedo Boys Jumpin Printed Leisure 17 Watershorts (Black/Blue/White) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1299",
    mrp: "1299",
    discount: "0% off",
  },
  {
   title: "Speedo Boys Jumpin Printed Leisure 17 Watershorts (Peri/Orange)",
    desc: "Speedo Boys Jumpin Printed Leisure 17 Watershorts (Peri/Orange) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1299",
    mrp: "1299",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Aqua Short (Black/Oxide Grey)",
    desc: "Speedo Boom Splice Aqua Short (Black/Oxide Grey) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1399",
    mrp: "1399",
    discount: "0% off",
  },
  {
   title: "Speedo AF Myrtle Raceback Legsuit (Black/White)",
    desc: "Speedo AF Myrtle Raceback Legsuit (Black/White) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1499",
    mrp: "1499",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo Jammer (Black/Charcol)",
    desc: "Speedo Gala Logo Jammer (Black/Charcol) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1199",
    mrp: "1199",
    discount: "0% off",
  },
  {
   title: "Speedo Womens Classic Legsuit (Navy/White)",
    desc: "Speedo Womens Classic Legsuit (Navy/White) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1999",
    mrp: "1999",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Racerback (Black/Pink)",
    desc: "Speedo Boom Splice Racerback (Black/Pink) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "2299",
    mrp: "2299",
    discount: "0% off",
  },
  {
   title: "Speedo Brigitte 1 Piece Swimdress (Black)",
    desc: "Speedo Brigitte 1 Piece Swimdress (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8113790001.jpg",
    currency: "INR ",
    price: "2299",
    mrp: "2299",
    discount: "0% off",
  },
  {
   title: "Speedo Bubble Fish All Over Splashback (Black/Blue)",
    desc: "Speedo Bubble Fish All Over Splashback (Black/Blue) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW807386A723.jpg",
    currency: "INR ",
    price: "1349",
    mrp: "1349",
    discount: "0% off",
  },
  {
   title: "Speedo Penny Tankini Swimmdress (Navy/Grey/White)",
    desc: "Speedo Penny Tankini Swimmdress (Navy/Grey/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811398C234.jpg",
    currency: "INR ",
    price: "2799",
    mrp: "2799",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Splice Legsuit (Black/Grey/Magenta)",
    desc: "Speedo Essential Splice Legsuit (Black/Grey/Magenta) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810392P004.jpg",
    currency: "INR ",
    price: "1999",
    mrp: "1999",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice AOP Swimdress (Jade/Navy)",
    desc: "Speedo Boom Splice AOP Swimdress (Jade/Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW808876B353.jpg",
    currency: "INR ",
    price: "2599",
    mrp: "2599",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice AOP Swimdress (Black/Pink)",
    desc: "Speedo Boom Splice AOP Swimdress (Black/Pink) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW808876B388.jpg",
    currency: "INR ",
    price: "2599",
    mrp: "2599",
    discount: "0% off",
  },
  {
   title: "Speedo Stormza Crop Top (Black/Stellar)",
    desc: "Speedo Stormza Crop Top (Black/Stellar) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811464C139.jpg",
    currency: "INR ",
    price: "1999",
    mrp: "1999",
    discount: "0% off",
  },
  {
   title: "Speedo Logo Panel Aquashort (Navy)",
    desc: "Speedo Logo Panel Aquashort (Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8092559336.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "1199",
    discount: "0% off",
  },
  {
   title: "Speedo Essential 7 Cm Brief (Black/White)",
    desc: "Speedo Essential 7 Cm Brief (Black/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8083540001.jpg",
    currency: "INR ",
    price: "699",
    mrp: "699",
    discount: "0% off",
  },
  {
   title: "Speedo Fit Splice Aquashort (Grey/Water/Black)",
    desc: "Speedo Fit Splice Aquashort (Grey/Water/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810378A586.jpg",
    currency: "INR ",
    price: "2399",
    mrp: "2399",
    discount: "0% off",
  },
  {
   title: "Speedo Monogram Racer-Back (Black/Magenta)",
    desc: "Speedo Monogram Racer-Back (Black/Magenta) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8092483597.jpg",
    currency: "INR ",
    price: "1799",
    mrp: "1799",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Black/White/Red)",
    desc: "Speedo Boom Splice Jammer (Black/White/Red) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810856B444.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Black/Danube)",
    desc: "Speedo Boom Splice Jammer (Black/Danube) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810856B442.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Boys Jammer (Black)",
    desc: "Speedo Houston Boys Jammer (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8BS9680001.jpg",
    currency: "INR ",
    price: "699",
    mrp: "699",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Boys Jammer (Navy)",
    desc: "Speedo Houston Boys Jammer (Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8BS9687780.jpg",
    currency: "INR ",
    price: "699",
    mrp: "699",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Boys Jammer (Black)",
    desc: "Speedo Houston Boys Jammer (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8MS4110001.jpg",
    currency: "INR ",
    price: "849",
    mrp: "849",
    discount: "0% off",
  },
  {
   title: "Speedo Monogram 6.5 Cm Brief (Black/White)",
    desc: "Speedo Monogram 6.5 cm Brief (Black/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8087503503.jpg",
    currency: "INR ",
    price: "499",
    mrp: "499",
    discount: "0% off",
  },
  {
   title: "Speedo Fit Splice Jammer (Navy/Jade/Grey)",
    desc: "Speedo Fit Splice Jammer (Navy/Jade/Grey) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810378B370.jpg",
    currency: "INR ",
    price: "2599",
    mrp: "2599",
    discount: "0% off",
  },
  {
   title: "Speedo Tri Bold Allover Aquashorts (Navy/Green/Lemon)",
    desc: "Speedo Tri Bold Allover Aquashorts (Navy/Green/Lemon) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW833162B518.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Oxide/Jade)",
    desc: "Speedo Boom Splice Jammer (Oxide/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810856B375.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Fusion Fun Essential Aquashort (Danube/Red/White)",
    desc: "Speedo Boom Splice Jammer (Navy/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW805394B402.jpg",
    currency: "INR ",
    price: "499",
    mrp: "499",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Navy/Jade)",
    desc: "Speedo Boom Splice Jammer (Navy/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810849B369.jpg",
    currency: "INR ",
    price: "999",
    mrp: "999",
    discount: "0% off",
  },
  {
   title: "Speedo Lycra 6.5 Cm Brief (Black)",
    desc: "Speedo Lycra 6.5 cm Brief (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8061240001.jpg",
    currency: "INR ",
    price: "399",
    mrp: "399",
    discount: "0% off",
  },
  {
   title: "Speedo Lighting Spritz Boys Jammer (Black/Orange/Red)",
    desc: "Speedo Lighting Spritz Boys Jammer (Black/Orange/Red) ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1149",
    mrp: "1149",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Black/Oxid Grey)",
    desc: "Speedo Boom Splice Jammer (Black/Oxid Grey) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810856B443.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Fit Splice Aquashort (Black/Yellow/Grey)",
    desc: "Speedo Fit Splice Aquashort (Black/Yellow/Grey) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810377A570.jpg",
    currency: "INR ",
    price: "2399",
    mrp: "2399",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Jammer (Navy/Jade)",
    desc: "Speedo Sports Logo Panel Aquashort (Black/Fluo Green) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810856B353.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Sports Logo Panel Aquashort (Black/Fluo Green)",
    desc: "Speedo Sports Logo Panel Aquashort (Black/Fluo Green) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW809530A763.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Fit Splice Aquashort (Grey/Water/Black)",
    desc: "Speedo Fit Splice Aquashort (Grey/Water/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810377A586.jpg",
    currency: "INR ",
    price: "2099",
    mrp: "2099",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Boys Aquashort (Black)",
    desc: "Speedo Houston Boys Aquashort (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8079680001.jpg",
    currency: "INR ",
    price: "599",
    mrp: "599",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Spliced Knee Suit (Black)",
    desc: "Speedo Essential Spliced knee Suit (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810391A729.jpg",
    currency: "INR ",
    price: "2299",
    mrp: "2299",
    discount: "0% off",
  },
  {
   title: "Speedo Boom Splice Aquashort (Navy/Jade)",
    desc: "Speedo Boom Splice Aquashort (Navy/Jade) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810855B353.jpg",
    currency: "INR ",
    price: "1399",
    mrp: "1399",
    discount: "0% off",
  },
  {
   title: "Speedo Splashback Junior Swimwear (Black)",
    desc: "Speedo Splashback Junior Swimwear (Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8007130001.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo Jammer (Navy/Citron)",
    desc: "Speedo Gala Logo Jammer (Navy/Citron) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811342P146.jpg",
    currency: "INR ",
    price: "899",
    mrp: "899",
    discount: "0% off",
  },
  {
   title: "Speedo Endurance+ Jammer (Danube/Black)",
    desc: "Speedo Endurance+ Jammer (Danube/Black) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW800722B490.jpg",
    currency: "INR ",
    price: "949",
    mrp: "949",
    discount: "0% off",
  },
  {
   title: "Speedo Splashback Junior Swimwear (Navy)",
    desc: "Speedo Splashback Junior Swimwear (Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8007137780.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo Jammer (Black/Red)",
    desc: "Speedo Gala Logo Jammer (Black/Red) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811355B346.jpg",
    currency: "INR ",
    price: "1249",
    mrp: "1249",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Jammer (Navy)",
    desc: "Speedo Houston Jammer (Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8MS4117780.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Speedo Gala Logo Jammer (Chroma Blue)",
    desc: "Speedo Gala Logo Jammer (Chroma Blue) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW811355C901.jpg",
    currency: "INR ",
    price: "1249",
    mrp: "1249",
    discount: "0% off",
  },
  {
   title: "Speedo Printed Boom Splice Capri (Jade/Navy)",
    desc: "Speedo Printed Boom Splice Capri (Jade/Navy) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8PSF04B353.jpg",
    currency: "INR ",
    price: "1499",
    mrp: "1499",
    discount: "0% off",
  },
  {
   title: "Speedo Marble Shin AOP Swimdress (Black/White/Grey)",
    desc: "Speedo Marble Shin AOP Swimdress (Black/White/Grey) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8088763503.jpg",
    currency: "INR ",
    price: "2799",
    mrp: "2799",
    discount: "0% off",
  },
  {
   title: "Speedo Fit Pinnacle X-Back Swimsuit (Black/Bali Blue/Gold)",
    desc: "Speedo Fit Pinnacle X-Back Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW810371A778L.jpg",
    currency: "INR ",
    price: "5499",
    mrp: "5499",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Pullback Swimsuit (Navy/White)",
    desc: "Speedo Essential Pullback Swimsuit (Navy/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8087387879M.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "1199",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Pullback Swimsuit (Black/White)",
    desc: "Speedo Essential Pullback Swimsuit (Black/White) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8087383503.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "1199",
    discount: "0% off",
  },
  {
   title: "Speedo Girls PulseDive Splashback (Navy/Aquatic/White)",
    desc: "Speedo Girls PulseDive Placement Panel Splashback (Navy/Aquatic/White). Leg Height: Medium ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8080778673.jpg",
    currency: "INR ",
    price: "949",
    mrp: "949",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Placement Aquashorts (Navy)",
    desc: "Speedo Essential Placement Aquashorts (Navy). Leg Height: 25cm. For Boys ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8055555332.jpg",
    currency: "INR ",
    price: "749",
    mrp: "749",
    discount: "0% off",
  },
  {
   title: "Speedo Racer-Back Swimdress (Deep Purple/Ecstatic)",
    desc: "Speedo Racer-back Swimdress (with boyleg). Colour - Deep Purple / Ecstatic ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW802878P331-1.jpg",
    currency: "INR ",
    price: "1899",
    mrp: "1899",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Aquashorts (Navy)",
    desc: "Speedo Houston Aquashorts (Navy). Leg Height: 27cm ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8141117780M.jpg",
    currency: "INR ",
    price: "649",
    mrp: "649",
    discount: "0% off",
  },
  {
   title: "Speedo Womens Classic Legsuit (Black/Oxid Grey)",
    desc: "Speedo Womens Classic Legsuit (Black/Oxid Grey) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8069947104M.jpg",
    currency: "INR ",
    price: "1599",
    mrp: "1599",
    discount: "0% off",
  },
  {
   title: "Speedo Houston Aquashorts (Black)",
    desc: "Speedo Houston Aquashorts (Black). Leg Height: 27cm ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSW8141110001M.jpg",
    currency: "INR ",
    price: "649",
    mrp: "649",
    discount: "0% off",
  },
  {
   title: "Speedo Racer-Back Swimdress",
    desc: "Speedo Racer-back Swimdress ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSWWM8028788592L.jpg",
    currency: "INR ",
    price: "1699",
    mrp: "1699",
    discount: "0% off",
  },
  {
   title: "Speedo Essential Allover Aquashorts",
    desc: "Speedo Essential Allover Aquashorts ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SPSWMN8055559213L.jpg",
    currency: "INR ",
    price: "799",
    mrp: "799",
    discount: "0% off",
  },
  {
   title: "Zoggs Etty Hip Racer Boys Swimsuit",
    desc: "Zoggs Etty Hip Racer Boys Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWBYEHRL.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "797.05",
    discount: "34% off",
  },
  {
   title: "Zoggs Brisbane Hip Racer Boys Swimsuit",
    desc: "Zoggs Brisbane Hip Racer Boys Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWBYBHRL.jpg",
    currency: "INR ",
    price: "1149",
    mrp: "763.80",
    discount: "34% off",
  },
  {
   title: "Zoggs Koolan Jammer Boys Swimsuit",
    desc: "Zoggs Koolan Jammer Boys Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWBYKJL.jpg",
    currency: "INR ",
    price: "1399",
    mrp: "930.05",
    discount: "34% off",
  },
  {
   title: "Zoggs Tots Bellambine Actionback Girls Swimsuit",
    desc: "Zoggs Tots Bellambine Actionback Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRTBABL.jpg",
    currency: "INR ",
    price: "1049",
    mrp: "697.30",
    discount: "34% off",
  },
  {
   title: "Zoggs Sunshine Beach Scoop Girls Swimsuit",
    desc: "Zoggs Sunshine Beach Scoop Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRSBSL.jpg",
    currency: "INR ",
    price: "1499",
    mrp: "996.55",
    discount: "34% off",
  },
  {
   title: "Zoggs Sunshine Beach X-Back Girls Swimsuit",
    desc: "Zoggs Sunshine Beach X-Back Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRSBXBL.jpg",
    currency: "INR ",
    price: "1299",
    mrp: "863.55",
    discount: "34% off",
  },
  {
   title: "Zoggs Ellis X-Back Girls Swimsuit",
    desc: "Zoggs Ellis X-Back Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGREXB.jpg",
    currency: "INR ",
    price: "1249",
    mrp: "830.30",
    discount: "34% off",
  },
  {
   title: "Zoggs Ellis Actionback Girls Swimsuit",
    desc: "Zoggs Ellis Actionback Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGREAB.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "797.05",
    discount: "34% off",
  },
  {
   title: "Zoggs Jewel Reef Action-Back Girls Swimsuit",
    desc: "Zoggs Jewel Reef Action-Back Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRJABL.jpg",
    currency: "INR ",
    price: "1399",
    mrp: "930.05",
    discount: "34% off",
  },
  {
   title: "Zoggs Seaford Halter Neck Girls Swimsuit",
    desc: "Zoggs Seaford Halter Neck Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRSHL.jpg",
    currency: "INR ",
    price: "1499",
    mrp: "996.55",
    discount: "34% off",
  },
  {
   title: "Zoggs Jewel Reef Spliceback Girls Swimsuit",
    desc: "Zoggs Jewel Reef Spliceback Girls Swimsuit ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ZGSWGRJSBL.jpg",
    currency: "INR ",
    price: "1499",
    mrp: "996.55",
    discount: "34% off",
  },
];
